import { NotificationMessage } from '@/components/notifications/types';
import { TFunction } from 'i18next';

interface JobCompletionInfo {
  isCompleted: boolean;
  requiresReview: boolean;
  isAutoApproved: boolean;
  isSentForReview: boolean;
}

export function useJobCompletionNotifications(t: TFunction) {
  function getJobCompletionNotification(
    completionInfo: JobCompletionInfo,
    jobName?: string,
    jobIuid?: string,
  ): NotificationMessage | undefined {
    const { isCompleted, requiresReview, isSentForReview, isAutoApproved } = completionInfo;

    // Only show notifications when job is completed
    if (!isCompleted) {
      return undefined;
    }

    const notificationDefaults = {
      type: 'success' as const,
      closable: true,
    };

    // If review is required but auto-approved (all work steps passed), show completed
    if (requiresReview && isAutoApproved) {
      return {
        ...notificationDefaults,
        message: t('JobCompleted', { name: jobName, iuid: jobIuid }),
      };
    }

    // If review is required and sent for review (not auto-approved), show sent for review message
    if (requiresReview && isSentForReview) {
      return {
        ...notificationDefaults,
        message: t('JobSentForReview', { name: jobName, iuid: jobIuid }),
      };
    }

    // Standard completion message (no review required) show completed
    return {
      ...notificationDefaults,
      message: t('JobCompleted', { name: jobName, iuid: jobIuid }),
    };
  }

  return { getJobCompletionNotification };
}
